import { render } from "./SimpleDialog.vue?vue&type=template&id=3abaf666&scoped=true&ts=true"
import script from "./SimpleDialog.vue?vue&type=script&lang=ts"
export * from "./SimpleDialog.vue?vue&type=script&lang=ts"

import "./SimpleDialog.vue?vue&type=style&index=0&id=3abaf666&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abaf666"]])

export default __exports__